<tt-page *ngIf="!!itemsListCheckPoints">
    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListCheckPoints"></tt-list>
</tt-page>
